import type { HighlighterApi } from '@highlight-cp/highlighter-api';

import { ProfileSurveyStatus } from './types';

/** Where the person is in filling out their account details (phone, email, address). */
export const getAccountDetailsStatus = (account?: HighlighterApi.Highlighter) => {
  const isNewAccount = account?.status === 'new' && (!account?.phoneVerified || !account?.address);
  // user has at least completed the first step of the account process (phone verified), but has not completed the entire flow
  const isAccountDetailsInProgress = isNewAccount && account?.phoneVerified;
  const accountDetailsStatus: ProfileSurveyStatus = isAccountDetailsInProgress
    ? ProfileSurveyStatus.IN_PROGRESS
    : isNewAccount
      ? ProfileSurveyStatus.NOT_STARTED
      : ProfileSurveyStatus.COMPLETE;

  return { isNewAccount, accountDetailsStatus };
};
